<template>
  <InfoLayout
    v-if="!isMobile"
    :current-path="reverseFull({ name: 'legal_case' })"
    :is-policy="false"
  >
    <template #title>
      {{ t('Битва за отзывы', options) }}
    </template>
    <template #content>
      <div>
        <AdminButton
          :text="t('Добавить судебное дело', options)"
          :link="reverseFull({ name: 'admin:info_legalcase_add' })"
        />
        <LegalCaseBanner
          :completed-cases="context.completed_cases"
          :courthearing-count="context.courthearing_count"
          :during-cases="context.during_cases"
          :won-cases="context.won_cases"
          :is-mobile="isMobile"
        />
        <LegalCaseCard
          v-for="legalCase in context.legal_cases.__items__"
          :id="legalCase.id"
          :key="legalCase.id"
          :legal-case="legalCase"
          :class="{ 'mb-4': !isMobile }"
        />
        <PagePagination
          v-if="pageRange.length > 1"
          data-qa="legal_case_pagination"
          :mobile="context.flavour !== 'full'"
          :pages-length="2"
          :current-page="context.page_num"
          @input="handleInput"
        />
      </div>
    </template>
  </InfoLayout>
  <div v-else>
    <AdminButton
      :text="t('Добавить судебное дело', options)"
      :link="reverseFull({ name: 'admin:info_legalcase_add' })"
    />
    <LegalCaseBanner
      :completed-cases="context.completed_cases"
      :courthearing-count="context.courthearing_count"
      :during-cases="context.during_cases"
      :won-cases="context.won_cases"
      :is-mobile="isMobile"
    />
    <LegalCaseCard
      v-for="legalCase in context.legal_cases.__items__"
      :id="legalCase.id"
      :key="legalCase.id"
      :legal-case="legalCase"
      :class="{ 'mb-4': !isMobile }"
    />
    <PagePagination
      v-if="pageRange.length > 1"
      data-qa="legal_case_pagination"
      :mobile="context.flavour !== 'full'"
      :pages-length="2"
      :current-page="context.page_num"
      @input="handleInput"
    />
  </div>
</template>

<script setup lang="ts">
import { useContextStore, useURLStore } from 'src/store'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/info/legal-case/types'
import LegalCaseCard from 'src/components/common/LegalCaseCard/components/LegalCaseCard.vue'
import PagePagination from 'src/components/common/PagePagination/PagePagination.vue'
import LegalCaseBanner from 'src/components/pages/info/legal-case/LegalCaseBanner.vue'
import AdminButton from 'src/components/common/AdminButton/AdminButton.vue'
import InfoLayout from 'src/layouts/info-pages/InfoLayout.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const pageRange = context.page.page_range
const isMobile = context.flavour === 'mobile'

const { reverseFull, urls, patch } = useURLStore()

if (typeof document === 'undefined') {
  patch({ legal_case: urls.legal_case })
}

function handleInput(param: { pageNumber: number }) {
  const pageLink = `${reverseFull({ name: 'legal_case' })}?page=${param.pageNumber}`

  if (typeof window !== 'undefined') {
    window.location.href = pageLink
  }
}
</script>
